import React from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import { themeClasses } from '../../config/themeClasses';

export default function LandingSocialProof() {
  const { t } = useLocale();

  return (
    <section className="border-b border-border-light py-8">
      <div className={themeClasses.landing.container}>
        <p className="text-center font-mono text-xs uppercase tracking-wider text-text-tertiary">
          {t('landingSocialProof')}
        </p>
      </div>
    </section>
  );
}
